import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import NavbarC from "./NavbarC";
import styles from "../Assets/Scss/wrapper.module.scss";

const Wrapper = ({ children }) => {
  const { pathname } = useLocation();

  // The redesigned Home page owns its own full-bleed layout and fixed nav
  // (see components/Nav.jsx), so it renders without the legacy Bootstrap
  // navbar/container that the other routes (e.g. /login) still use.
  if (pathname === "/") {
    return <div className={styles.container}>{children}</div>;
  }

  return (
    <Container fluid="true" className={styles.container}>
      <NavbarC />
      <Container fluid="true">{children}</Container>
    </Container>
  );
};
export default Wrapper;
